import { Component, Input } from '@angular/core';
import { FrequenceEnum } from '../../constants/frequence.config';

@Component({
  selector: 'app-total-recap',
  templateUrl: './total-recap.component.html',
  styleUrls: ['./total-recap.component.scss'],
  standalone: false
})
export class TotalRecapComponent {
  @Input()
  size: 'small' | 'default' = 'default';

  @Input()
  theme: 'turquoise' | 'green' | 'graphite' = 'green';

  @Input()
  amount: number;

  @Input()
  frequency: FrequenceEnum.ANNUEL | FrequenceEnum.MENSUEL = FrequenceEnum.ANNUEL;

  config: Record<string, { textColor: string; backgroundColor?: string; backgroundColorCustom?: string }> = {
    green: {
      backgroundColor: 'light-primary-1',
      textColor: 'dsd-c-light-primary-t'
    },
    turquoise: {
      backgroundColor: 'light-turquoise-2',
      textColor: 'dsd-c-light-confirmation-t'
    },
    graphite: {
      backgroundColor: 'light-graphite-1',
      textColor: 'dsd-c-light-graphite-t'
    }
  };

  get frequencyLabel() {
    return this.frequency === FrequenceEnum.MENSUEL ? 'label-frequences.mensuel' : 'label-frequences.annuel';
  }

  get backgroundColor() {
    return this.config[this.theme].backgroundColor;
  }

  get textColor() {
    return this.config[this.theme].textColor;
  }

  get backgroundColorCustom() {
    return this.config[this.theme].backgroundColorCustom;
  }

  get amountSize() {
    return `dsd-t-${this.size === 'small' ? 5 : 3}`;
  }
}
